import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from './pages/DetailPage';
import {useVerifiedPermissions} from '../../hooks/useVerifiedPermissions';
import {rbacActions} from '../../config/rbac/actions';

// FNP-973: READ-ONLY module — index and detail only. No add and no edit route,
// because the deployed schema has no hosted-zone mutation (writes are FNP-977).
export const HostedZonesLayout = () => {

    const {allowedActions} = useVerifiedPermissions();

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListHostedZones) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/dashboard'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetHostedZone) ? (
                        <DetailPage/>
                    ) : (
                        <Navigate to='/hosted-zones'/>
                    )
                }
            />
        </Routes>
    );
};
